import { FormGroup, Label, Input } from "reactstrap";

const Form = ({ values, errors, touched, handleBlur, handleChange }) => {
	return (
		<>
			<FormGroup>
				<Label for="name">Namn</Label>
				<Input
					className={errors.name ? "is-invalid" : ""}
					autoComplete="off"
					name="name"
					value={values.name}
					onChange={handleChange}
					onBlur={handleBlur}
				></Input>
				{errors.name && touched.name && <span className="text-danger">{errors.name}</span>}
			</FormGroup>
			<FormGroup>
				<Label for="name">E-postmottagare</Label>
				<Input
					className={errors.replyEmail ? "is-invalid" : ""}
					autoComplete="off"
					name="replyEmail"
					value={values.replyEmail}
					onChange={handleChange}
					onBlur={handleBlur}
				></Input>
				{errors.replyEmail && touched.replyEmail && <span className="text-danger">{errors.replyEmail}</span>}
			</FormGroup>
		</>
	);
};
export default Form;
